import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import { useParams, useLocation } from 'react-router-dom'

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';





function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));




const Faqs = () =>{
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const Faq = () => {
     
                  
    }
    return(
        <div className="container ">
          <div className="vrfy-section page-faq page">
              
            <h1>Frequently Asked Questions (FAQ)</h1>
            <ul>
                <li>
                    <div className="faq-header-wrapper"><h4>What is E-vrfy?</h4></div>
                    <div className="faq-p-wrapper"><p>E-vrfy is the Judiciary’s Document Authentication and Verification system.
                </p>
                </div>
                </li>
                <li>
                <h4>Why should I use E-vrfy?</h4>
                <p>
                E-vrfy allows for the internal authentication of court generated documents which can then be verified by relevant external parties.
                </p>
                </li>
                <li>
                <h4>Through E-vrfy, will anyone be able to access another person's court documents?</h4>
                <p>Answer required.
                </p>
                </li>
                <li>
                <h4>Can parties "opt out" of E-vrfy?</h4>
                <p>Answer required.
                </p>
                </li>
                <li>
                <h4>How can I verify a court document using E-vrfy?</h4>
                <p>Answer required.
                </p>
                </li>
                <li>
                <h4>Can I verify the authenticity of a signature without Adobe Acrobat?</h4>
                <p>Answer required.
                </p>
                </li>
                <li>
                <h4>Will we know if a court document has been updated?</h4>
                <p>Answer required.
                </p>
                </li>
                <li>
                <h4>If my court document was issued before November 2021</h4>
                <p>Answer required.
                </p>
                </li>
                <li>
                <h4>Why should a person go to the evrfy.ttlawcourts.org website if they already have a softcopy of a Court Order?</h4>
                <p>Answer required.
                </p>
                </li>
                <li>
                <h4>Will e-probate grants before November 2021 be re-issued and added to the E-vrfy?</h4>
                <p>Answer required.
                </p>
                </li>
                <li>
                <h4>If the Court Order I receive after November 2021 does not have a QR Code and an Access Code, does it mean that it is a forgery?</h4>
                <p>Answer required.
                </p>
                </li>
                <li>
                <h4>Must I be a party to a case in order to access the E-vrfy system?</h4>
                <p>Answer required.
                </p>
                </li>
            </ul>

          </div>
 
        </div>
    );




};



export default Faqs;

